import React from 'react';
import {Checkbox, Radio} from 'antd';
const RadioGroup = Radio.Group;
import {WeaSearchGroup, WeaFormItem, WeaInput, WeaHelpfulTip} from 'ecCom';
import {WeaLocaleProvider} from 'ecCom';
const getLabel = WeaLocaleProvider.getLabel;
import EType from './base/EType';
import ETitle from './base/ETitle';
import WeaMaterialLib from './base/WeaMaterialLib';

// Flash元素
export default class Content_Flash extends React.Component {
    state = {
        eFlashShow: this.props.eFlashShow,
        eFlashForm: this.props.eFlashForm
    };

    render() {
        const {eFlashShow, eFlashForm} = this.state;

        let EShowSetting = <div></div>;
        let EFlashFrom = <div></div>;
        if (this.props.eShareLevel == '2') {
            EShowSetting = (
                <WeaFormItem label={getLabel(33549, '显示设置')} labelCol={{span: 6}} wrapperCol={{span: 16}}>
                    <span>{getLabel(386530, '高度：')}</span>
                    <WeaInput value={eFlashShow.height} style={{width: '50px'}} onChange={value => this.setState({eFlashShow: {...eFlashShow, height: value}})}/>
                </WeaFormItem>
            );

            const radioStyle = {
                display: 'block',
                height: '30px',
                lineHeight: '30px',
                marginBottom: '5px'
            };
            EFlashFrom = (
                <WeaFormItem label={getLabel(386579, 'Flash来源')} labelCol={{span: 6}} wrapperCol={{span: 16}}>
                    <RadioGroup value={eFlashForm.type || '1'} onChange={e => this.setState({eFlashForm: {...eFlashForm, type: e.target.value}})}>
                        <Radio style={radioStyle} value="1">{getLabel(125333, '选择文件')}</Radio>
                        <Radio style={radioStyle} value="2">{getLabel(386575, 'URL路径')}</Radio>
                    </RadioGroup>
                    <div style={{position: 'absolute', top: 0, left: 0, width: '100%', marginLeft: '85px', paddingRight: '85px'}}>
                        <div style={radioStyle}>
                            <WeaMaterialLib value={eFlashForm.src} onChange={value => this.setState({eFlashForm: {...eFlashForm, src: value}})}/>
                        </div>
                        <div style={radioStyle}>
                            <WeaInput value={eFlashForm.url} onChange={value => this.setState({eFlashForm: {...eFlashForm, url: value}})}/>
                            <WeaHelpfulTip style={{position: 'absolute',
                                paddingLeft: '10px'}} title={getLabel(516348,'因chrome浏览器禁用flash，故chrome下不支持上传.swf、.flv格式视频') }/>
                        </div>
                    </div>
                </WeaFormItem>
            );
        }

        return (
            <div>
                <WeaSearchGroup title={getLabel(81711, '基本信息')} needTigger={true} showGroup={true}>
                    <EType ref="eType" value={this.props.eBaseName}/>
                    {this.props.eShareLevel == '2' ? <ETitle ref="eTitle" eid={this.props.eid} value={this.props.eTitle}/> : ''}
                    {EShowSetting}
                    {EFlashFrom}
                </WeaSearchGroup>
            </div>
        );
    }

    getSaveValues() {
        return {
            eContentTitle: this.refs['eTitle'] ? this.refs['eTitle'].getSaveValues() : this.props.eTitle,
            eContentFlashShow_height: this.state.eFlashShow.height,
            eContentFlashShow_autoPlay: this.state.eFlashShow.autoPlay,
            eContentFlashForm_type: this.state.eFlashForm.type || '1',
            eContentFlashForm_src: this.state.eFlashForm.src,
            eContentFlashForm_url: this.state.eFlashForm.url
        };
    }
}


// WEBPACK FOOTER //
// ../src4js/pc4mobx/portal/elements/components/common/setting_new/content/Content_Flash.js